import { Music } from "lucide-react";

const SourceCard = ({
  post: {
    postUsername = "@username",
    profileImage,
    hasVideo = false,
    backgroundColor = "bg-green-400",
    source = "not available",
  },
}) => {
  console.log("username being returned: ", postUsername, profileImage);

  return (
    <div className="w-64 rounded-lg border border-gray-200 bg-gray-100 px-4 py-2">
      <div className="flex justify-start gap-3">
        <div
          className={`h-12 w-12 rounded-lg ${backgroundColor} flex items-center justify-center overflow-hidden`}
        >
          {profileImage ? (
            <img
              src={profileImage}
              alt="Profile"
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="h-full w-full bg-gradient-to-br from-red-400 to-red-600"></div>
          )}
        </div>
        <div className="flex-1">
          <div className="text-left text-sm font-semibold text-gray-900">
            {postUsername === "" ? "no username" : postUsername}
          </div>
          <div className="flex w-fit items-center gap-1 rounded-md bg-gray-200 px-2 text-gray-600">
            <span className="text-sm">
              {source != "" ? source : "not available"}
            </span>
            <Music className="h-4 w-4" />
          </div>
        </div>
        {hasVideo && (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-black bg-opacity-20">
            <div className="ml-1 h-0 w-0 border-b-[4px] border-l-[6px] border-t-[4px] border-b-transparent border-l-white border-t-transparent"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SourceCard;
